import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// current User Details
export const GetDataCenter = createAsyncThunk(
  "datacenter/getDataCenter",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/location/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during data center  data.";
      return rejectWithValue(errorMessage);
    }
  }
);
// save a new user
export const saveDataCenter = createAsyncThunk(
  "datacenter/saveDataCenter",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/location/new`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during adding data center.";
      return rejectWithValue(errorMessage);
    }
  }
);

// get all the users --admin
export const getAllDataCenter = createAsyncThunk(
  "datacenter/getAllDataCenter",
  async (data, { rejectWithValue }) => {
    try {

      console.log('getting data from data center')

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/location/all`,
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
        // {
        //   headers: { Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3NDQ3MjRiZWRjYjU5YjQ2NzMxM2FhYyIsInJlZnJlc2hUb2tlbiI6ImMyYTI1OThhOWE1MDUxMjAiLCJpYXQiOjE3MzI2MjcxMzYsImV4cCI6MTczMjcxMzUzNn0.--cyDg0YrNo75GztH0edknspRD40Cn9fCUVkbqcn4EM` },
        // }
      );

       console.log('getting data of data center ', response?.data)
      // Check if the login is successful
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data?.result;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "getting error during  save data of data center.";
      return rejectWithValue(errorMessage);
    }
  }
);

// update a user  --admin
export const updateDataCenter = createAsyncThunk(
  "datacenter/updateDataCenter",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/location/admin/${data.id}`,
        data.data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during update data center.";
      return rejectWithValue(errorMessage);
    }
  }
);

// block a user  --admin
export const blockDataCenter = createAsyncThunk(
  "datacenter/blockDataCenter",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/location/admin/${data.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.message);
      }
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred during delete data center.";
      return rejectWithValue(errorMessage);
    }
  }
);



